import React from "react";
import ContentLoader from "react-content-loader";

const ActivitySkeleton = ({ webAppTheme }) => {
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";
  return (
    <ContentLoader
      viewBox="0 0 100% 1000"
      height={1000}
      width={"100%"}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      speed={1}
      title="Loading Activity..."
      style={{ margin: "24px" }}
    >
      <rect x="56" y="21" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="24" r="24" />

      <rect x="56" y="77" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="80" r="24" />

      <rect x="56" y="133" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="136" r="24" />

      <rect x="56" y="189" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="192" r="24" />

      <rect x="56" y="245" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="248" r="24" />

      <rect x="56" y="301" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="304" r="24" />

      <rect x="56" y="357" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="360" r="24" />

      <rect x="56" y="413" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="416" r="24" />

      <rect x="56" y="469" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="472" r="24" />

      <rect x="56" y="525" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="528" r="24" />

      <rect x="56" y="581" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="584" r="24" />

      <rect x="56" y="637" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="640" r="24" />

      <rect x="56" y="693" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="696" r="24" />

      <rect x="56" y="749" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="752" r="24" />

      <rect x="56" y="805" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="808" r="24" />

      <rect x="56" y="861" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="864" r="24" />

      <rect x="56" y="917" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="920" r="24" />

      <rect x="56" y="973" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="976" r="24" />

      <rect x="56" y="1029" rx="4" ry="4" width="350" height="6" />
      <circle cx="24" cy="1032" r="24" />
    </ContentLoader>
  );
};

export default ActivitySkeleton;
